export default __webpack_public_path__ + "static/media/Shape_15.557068c7.png";